<template>
  <div>
    <b-modal
      ref="authenticate-modal"
      hide-header
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      body-class="authenticate-modal-body"
      data-test-id="authenticate-modal"
    >
      <div class="text-center text-white mb-2">Your session expired.</div>
      <div class="text-center text-white" :class="{ 'mb-4': !isCaseActive, 'mb-2': isCaseActive }">
        Please authenticate again or logout.
      </div>
      <div v-if="isCaseActive" class="text-center text-danger mb-4">
        You currently have a case open. If you logout you will no longer be able to add data to the case.
      </div>
      <b-alert id="login__error-required" :show="!!errorMessage" variant="danger">
        {{ errorMessage }}
      </b-alert>

      <b-form v-if="!isCognitoSignin()" id="login__form" data-test-id="LoginForm" @submit.prevent="onSubmit()">
        <b-form-group>
          <b-form-input
            id="login__username-or-email"
            :value="user && user.username ? user.username : ''"
            data-cy-username
            type="text"
            placeholder="Username or email"
            disabled
          />
        </b-form-group>
        <b-form-group :invalid-feedback="passwordFieldFeedback">
          <b-form-input
            id="login__password"
            v-model="form.password"
            data-cy-password
            type="password"
            placeholder="Password"
            :state="isPasswordValid"
            @keyup.enter="onSubmit()"
          />
        </b-form-group>

        <b-button
          v-show="!isLoading"
          id="login__signin-button"
          data-cy-login-button
          variant="danger"
          block
          class="mt-2"
          @click.prevent="onSubmit()"
        >
          Login
        </b-button>

        <b-button v-show="isLoading" id="login__signin-loading-indicator" variant="danger" block class="mt-2" disabled>
          <b-spinner small />
          Logging in...
        </b-button>
      </b-form>

      <b-button
        v-if="isCognitoSignin() && user"
        data-test-id="ContinueSSOButton"
        variant="danger"
        block
        @click.prevent="redirectToCognito()"
      >
        Continue as {{ user.displayName }}
      </b-button>

      <b-button
        v-show="!isLoading"
        id="login__logout-button"
        data-cy-logout-button
        variant="link"
        class="text-danger"
        block
        @click.prevent="onLogout()"
      >
        Logout
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import get from "lodash.get";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "Authenticate",
  data() {
    return {
      form: {
        password: "",
      },
    };
  },
  computed: {
    ...mapGetters("Authenticate", ["isAuthenticate"]),
    ...mapState("Login", ["user", "passwordError", "errorMessage", "isLoading"]),
    ...mapGetters("Login", ["workspaceApp"]),
    ...mapGetters("Case", ["isCaseActive"]),
    isPasswordValid() {
      return this.passwordError ? false : undefined;
    },
    passwordFieldFeedback() {
      return this.passwordError;
    },
  },
  watch: {
    isAuthenticate(newValue) {
      if (newValue) {
        this.showModal();
      } else {
        this.hideModal();
      }
    },
  },
  methods: {
    ...mapActions("Login", ["authenticate", "logout"]),
    ...mapActions("Authenticate", ["setAuthenticate"]),
    showModal() {
      this.$refs["authenticate-modal"].show();
    },
    hideModal() {
      this.$refs["authenticate-modal"].hide();
    },
    onSubmit() {
      this.authenticate({
        username: this.user && this.user.username ? this.user.username : "",
        password: this.form.password,
      });
    },
    onLogout() {
      this.setAuthenticate(false);
      this.logout();
    },
    isCognitoSignin() {
      return !!get(this.workspaceApp, "cognito.signin");
    },
    redirectToCognito() {
      window.location.href = get(this.workspaceApp, "cognito.signin");
    },
  },
};
</script>

<style lang="scss">
.authenticate-modal-body {
  background-color: #222;
  border: 3px solid #ccc;
  border-radius: 4px;
}
</style>
